import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircle';
import { Box, Button, Card, Link, Typography } from '@mui/material';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import React, { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { NavLink as RouterLink, useNavigate } from 'react-router-dom';
import { forgotSx } from 'src/common/CommomSxs';
import { API } from 'src/common/config/API';
import {
  emailRegex,
  goBackToLogin,
  loginBackgroundPath,
  logoWithoutBackground,
  resetPasswordText
} from 'src/common/config/TextMessage';
import { IForgotForm } from 'src/content/forgot/types/formTypes';

const Forgot = () => {
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [error, setError] = useState<string>('');
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<IForgotForm>();
  const [isSuccessfullySubmitted, setIsSuccessfullySubmitted] =
    React.useState(false);
  const navigate = useNavigate();

  // SignUp Form Submit handler
  const onSubmit: SubmitHandler<IForgotForm> = async (request) => {
    setLoading(true);
    const { email } = request;
    API.forgetPassword(
      API.EndPoint.forgetPassword,
      API.Method.post,
      undefined,
      { email },
      (response) => {
        const responsData = { ...response.data };

        if (responsData.status === 'success') {
          setIsSuccessfullySubmitted(true);
          setSuccessMessage(responsData.message);
          setTimeout(() => {
            setLoading(false);
            setIsSuccessfullySubmitted(false);
            setSuccessMessage('');
          }, 4000);
        } else {
          setError(responsData.message);
          setTimeout(() => {
            setError('');
            setLoading(false);
          }, 2000);
        }
      }
    );
  };

  // Forgot validation validation
  const validationErrorMessage: any = {
    email: {
      required: 'Email Address is required',
      pattern: {
        value: emailRegex,
        message: 'Invalid email address'
      }
    }
  };
  return (
    <>
      <div
        className="flex justify-center align-middle"
        style={{ width: '100%', height: '100%' }}
      >
        <div className="flex items-center justify-center relative h-full w-full">
          <div
            className="blur-sm login-image-bg "
            style={{ backgroundImage: `url(${loginBackgroundPath})` }}
          />
          <div className="absolute">
            <Card
              className="px-10 py-14 md:px-20 md:py-16 mx-5"
              sx={forgotSx.card}
            >
              <Box>
                <Box className="flex flex-col justify-center items-center ">
                  <Box className="mb-14 flex justify-center">
                    <img
                      src={logoWithoutBackground}
                      loading="lazy"
                      width={'150px'}
                    />
                  </Box>
                  <Typography
                    mt={-5}
                    mb={2}
                    sx={forgotSx.resetPasswordTypoSx}
                  >
                    {resetPasswordText}
                  </Typography>
                  <Box
                    component="form"
                    noValidate
                    autoComplete="off"
                    onSubmit={handleSubmit(onSubmit)}
                    className="w-full"
                  >
                    <Stack spacing={2} height="100%" alignItems="center">
                      <TextField
                        variant="filled"
                        InputProps={{ disableUnderline: true }}
                        id="outlined-email-input"
                        label="Email"
                        type="text"
                        size="small"
                        autoComplete="email"
                        className="w-full"
                        fullWidth
                        {...register('email', validationErrorMessage.email)}
                        helperText={errors.email ? errors.email.message : ''}
                        error={!!errors.email}
                      />

                      <Stack width="100%">
                        {!isSuccessfullySubmitted && (
                          <Button
                            fullWidth
                            variant="contained"
                            type="submit"
                            className="w-full"
                            disabled={loading}
                          >
                            {loading ? (
                              <CircularProgress size={24} />
                            ) : (
                              'Send Link'
                            )}
                          </Button>
                        )}

                        {isSuccessfullySubmitted && (
                          <Alert
                            icon={
                              <CheckCircleOutlineIcon
                                fontSize="inherit"
                                sx={forgotSx.successMessage}
                              />
                            }
                            severity="success"
                            className="mt-2"
                          >
                            {successMessage}
                          </Alert>
                        )}
                        {error && (
                          <Alert severity="error" className="mt-4">
                            {/* {error} */}
                            <span
                              dangerouslySetInnerHTML={{
                                __html: `${error}`
                              }}
                            />
                          </Alert>
                        )}

                        {!isSuccessfullySubmitted && (
                          <div className="flex justify-end mt-4 md:mb-10">
                            <Link to="/signin" component={RouterLink}>
                              {goBackToLogin}
                            </Link>
                          </div>
                        )}
                      </Stack>
                    </Stack>
                  </Box>
                </Box>
              </Box>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default Forgot;
